import React from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./Carousel.styles.scss";

const Carousel = ({ images = [] }) => {
  const settings = {
    dots: false,
    infinite: images.length > 1,

    slidesToShow: 1,
    slidesToScroll: 1,

    speed: 500,

    autoplay: images.length > 1,
    autoplaySpeed: 3000,

    pauseOnHover: true,

    arrows: false,

    centerMode: false,
    variableWidth: false,

    adaptiveHeight: true,
  };

  return (
    <div className="carousel slider-container">
      <Slider {...settings}>
        {images.map((image, i) => (
          <div key={i} className="slide">
            <div className="image-container">
              <img
                src={image}
                alt={`Event poster ${i + 1}`}
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Carousel;